<script setup>
  const props = defineProps({
    whiteOverlay: {
      default: false,
      type: Boolean
    }
  });
</script>

<template>
  <span
    :class="['absolute top-0 left-0 w-full h-full bg-gray-950/60 z-10', props.whiteOverlay ? 'linear-bg-white' : 'linear-bg-black']"
  />
</template>

<style scoped>
.linear-bg-white {
  background: linear-gradient(125.8deg, #fffffff2 50%, #ffffffd6 62%, #c6d9cb00);
}

.linear-bg-black {
  background: linear-gradient(125.8deg, #0000007a 50%, #00000063 62%, #00000000);
}
</style>
